import React from 'react';

import { IsRibbonEnabledContext } from '../is-ribbon-enabled-context';
import type { IsRibbonEnabledProviderProps } from '../types';

/**
 * __Is ribbon enabled provider__
 *
 * Used to provide a value indicating if Ribbon is enabled or not.
 */
export const IsRibbonEnabledProvider = ({
	children,
	value,
}: IsRibbonEnabledProviderProps): React.JSX.Element => {
	return (
		<IsRibbonEnabledContext.Provider value={value}>{children}</IsRibbonEnabledContext.Provider>
	);
};
